import { render } from "./ResourcesView.html?vue&type=template&id=48b98766&scoped=true&external"
import script from "./ResourcesView.js?vue&type=script&lang=js&external"
export * from "./ResourcesView.js?vue&type=script&lang=js&external"

import "./ResourcesView.css?vue&type=style&index=0&id=48b98766&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b98766"]])

export default __exports__